import {Injectable} from '@angular/core';
import {HttpClient} from '@angular/common/http';
import {AbstractActionService} from '../../../../../core/service/v2/service/action/abstractAction.service';
import {CustomizeHttpUrlGenerator} from '../../../../../../store/core/url/customizeHttpUrlGenerator';
import {PayloadWithId} from '../../../../../core/service/payload/payloadWithId';

@Injectable()
export class MedicalRecordPainDeleteIntensityActionService
    extends AbstractActionService<PayloadWithId, any> {

    public constructor(customizeHttpUrlGenerator: CustomizeHttpUrlGenerator,
                       httpClient: HttpClient) {
        super('MedicalPain', 'delete-intensity', customizeHttpUrlGenerator, httpClient);
    }
}
